// react
import { ReactNode } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Box, SxProps, Typography } from '@mui/material';

// ui
import { IconCircle, IconCircleProps } from '../IconCircle/IconCircle';

// dates
import { toRelativeTime } from '../../../utils/dates';

// props
export interface NotificationProps {
	children: ReactNode;
	date?: Date;
	hasBorder?: boolean;
	type?: IconCircleProps['type'];
}

export const Notification = ({
	children,
	date,
	hasBorder = true,
	type = 'default',
}: NotificationProps) => {
	// hooks
	const { i18n } = useTranslation();

	return (
		<Box
			sx={(theme) => {
				let sx: SxProps = {
					display: 'flex',
					alignItems: 'flex-start',
					gap: theme.spacing(1),
					padding: theme.spacing(2),
					'&:last-child': {
						border: 'none',
					},
				};

				if (hasBorder) {
					sx = {
						...sx,
						borderBottom: `1px ${theme.palette.divider} solid`,
					};
				}

				return sx;
			}}>
			<IconCircle size="sm" type={type} />
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					flex: '1',
				}}>
				<Typography variant="caption">{children}</Typography>
				{date && (
					<Box
						component="time"
						sx={(theme) => {
							return {
								color: theme.palette.brand.grey[500],
							};
						}}>
						<Typography component="div" variant="caption">
							{toRelativeTime(date, i18n.language)}
						</Typography>
					</Box>
				)}
			</Box>
		</Box>
	);
};
